"use client";
import { useState } from "react";
import FormField from "./FormField";
import { API } from "API/API";
import { printHTML } from "hooks/utils/formatter";

const ContactForm = ({ data }) => {
  const [feedbackMailSend, setFeedbackMailSend] = useState(null);
  const block_data = data?.attrs?.data;

  const { form_fields, selecteer_formulier, titel_formulier } =
    block_data || {};

  const form_id =
    selecteer_formulier && selecteer_formulier?.length > 0
      ? selecteer_formulier[0]
      : false;

  async function handleFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const dateFields = form_fields?.filter((field) => field?.type == "date");
    const radioFields = form_fields?.filter((field) => field?.type == "radio");

    const checkboxFields = form_fields?.filter(
      (field) => field?.type == "checkbox"
    );

    const form = e.target;
    const formData = new FormData(form);
    formData.append("_wpcf7_unit_tag", "wpcf7-f" + form_id + "-o1");

    const radioButtons = form.querySelectorAll('input[type="radio"]');

    const radioGroups = Array.from(radioButtons).reduce((acc, radioButton) => {
      const name = radioButton.getAttribute("name");
      if (!acc[name]) {
        acc[name] = [];
      }
      acc[name].push(radioButton);
      return acc;
    }, {});

    Object.entries(radioGroups).forEach(([name, radioGroup]) => {
      const checkedRadio = radioGroup.find((radio) => radio.checked);
      const index = radioGroup.indexOf(checkedRadio);

      (radioFields || [])?.forEach((field) => {
        const { raw_name } = field || {};
        const { raw_values } = field || [];

        if (raw_name == name) {
          formData.append(raw_name, raw_values[index]);
        }
      });
    });

    let fieldsObj = Object.fromEntries(formData.entries());
    dateFields.forEach((field) => {
      const fieldName = field?.raw_name;
      const dateValue = fieldsObj[fieldName];
      if (dateValue) {
        const date = new Date(dateValue);
        const formattedDate = date.toISOString().split("T")[0]; // YYYY-MM-DD
        fieldsObj[fieldName] = formattedDate;
      }
    });

    checkboxFields.forEach((field) => {
      const { raw_name } = field || {};
      const { raw_values } = field || [];

      const findCheckboxes = Object.keys(fieldsObj).filter((key) =>
        key.startsWith(raw_name + "_")
      );

      findCheckboxes.forEach((checkbox) => {
        const index = checkbox.split("_")[1];
        const checkboxValue = raw_values[index];
        if (checkboxValue) {
          fieldsObj[raw_name] = fieldsObj[raw_name] || [];
          fieldsObj[raw_name].push(printHTML(checkboxValue));
        }

        delete fieldsObj[checkbox];
      });
    });

    const makeNewFormData = new FormData();
    Object.entries(fieldsObj).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          makeNewFormData.append(key + "[]", item);
        });
      } else {
        makeNewFormData.append(key, value);
      }
    });

    const result = await API.form.submit(form_id, makeNewFormData);
    if (result?.status == "mail_sent") {
      form.reset();
    }

    setFeedbackMailSend({
      message: result?.message,
      fields: result?.invalid_fields,
    });

    setTimeout(() => {
      setFeedbackMailSend(null);
    }, 8000);
  }

  if (!form_fields || form_fields?.length === 0 || !form_id) {
    return;
  }

  return (
    <section className="max-w-app mx-auto px-4 mb-14 md:mb-20 xl:px-0">
      <div
        className="w-full max-w-gutenberg-container justify-self-center mx-auto
               bg-white rounded-10 pt-8 pb-10 md:py-20 px-6 md:px-28"
      >
        {titel_formulier && <h5 className="mb-6">{titel_formulier}</h5>}
        <form
          className="flex flex-col gap-3"
          onSubmit={handleFormSubmit}
        >
          {form_fields?.map((field, idx) => {
            return (
              <FormField
                field={field}
                key={field?.raw_name + "_" + idx}
                feedbackMailSend={feedbackMailSend}
              />
            );
          })}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
